<template>
  <IconRoundText>
    <MedalSVG slot="icon" />
    No CyberClass {{ user.created_at }}
  </IconRoundText>
</template>

<script>
import IconRoundText from '@/components/text/IconRoundText'
import MedalSVG from '@/components/svg/MedalSVG'

export default {
  components: {
    IconRoundText,
    MedalSVG,
  },

  props: {
    user: { type: Object, required: true }
  }
}
</script>